import { isCesiumIonAssetType } from "./CesiumIonAssetType";
import { isCesiumIonAssetEndpointAttribution, } from "./CesiumIonAssetEndpointAttribution";
import { isCesiumIonExternalAssetType } from "./CesiumIonExternalAssetType";
/**
 * Returns whether the given object matches the BingMapsOptions type
 * @param obj Object to check
 */
export function isBingMapsOptions(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    if (typeof obj.url !== "undefined" && typeof obj.url !== "string")
        return false;
    if (typeof obj.mapStyle !== "undefined" && typeof obj.mapStyle !== "string")
        return false;
    if (typeof obj.key !== "undefined" && typeof obj.key !== "string")
        return false;
    return true;
}
/**
 * Returns whether the given object matches the CesiumIonExternalAssetEndpoint type
 * @param obj Object to check
 */
export function isCesiumIonExternalAssetEndpoint(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    if (typeof obj.type !== "undefined" && !isCesiumIonExternalAssetType(obj.externalType))
        return false;
    if (typeof obj.type !== "undefined" && !isCesiumIonAssetType(obj.type))
        return false;
    if (Array.isArray(obj.attributions)) {
        for (const v of obj.attributions) {
            if (!isCesiumIonAssetEndpointAttribution(v))
                return false;
        }
    }
    if (typeof obj.options !== "undefined" && typeof obj.options !== "object")
        return false;
    return true;
}
